// Зеркало серверной политики из payment-service/internal/sso/merchant_access.go.
// Бэкенд применяет её и к кабинету мерчанта, и к sign-up трейдера, поэтому
// generate/validate ниже нейтральны к типу учётной записи; парную проверку с
// подтверждением оставляем мерчанту — у формы трейдера второго поля нет.
const LOGIN_PATTERN = /^[a-z0-9][a-z0-9._-]{2,99}$/;
const COMMON_PASSWORDS = new Set([
    "123456789012345",
    "letmeinletmein",
    "password1234567",
    "passwordpassword",
    "qwertyuiopasdfgh",
]);

export function normalizeMerchantPortalLogin(login: string): string {
    return login.trim().toLowerCase();
}

export function generateMerchantPortalPassword(): string {
    // 20 random bytes = 160 bits of entropy. Hex keeps the result printable,
    // copy-safe and well below bcrypt's 72-byte input limit.
    const bytes = new Uint8Array(20);
    crypto.getRandomValues(bytes);
    const random = Array.from(bytes, (value) => value.toString(16).padStart(2, "0")).join("");
    return `Mlk-${random}`;
}

export function validateCredentialLogin(loginInput: string): string | null {
    if (!LOGIN_PATTERN.test(normalizeMerchantPortalLogin(loginInput))) {
        return "Логин: 3–100 символов; латинские буквы, цифры, точка, дефис или подчёркивание.";
    }
    return null;
}

export function validateCredentialPassword(password: string): string | null {
    if (password.length < 15) {
        return "Пароль должен содержать не менее 15 символов.";
    }
    if (new TextEncoder().encode(password).length > 72) {
        return "Пароль не должен превышать 72 байта — это предел bcrypt.";
    }
    if (/[\u0000-\u001f\u007f-\u009f]/.test(password)) {
        return "Пароль не должен содержать управляющие символы.";
    }
    if (COMMON_PASSWORDS.has(password.toLowerCase().replace(/[^a-z0-9]/g, ""))) {
        return "Выберите менее распространённый пароль.";
    }
    return null;
}

export function validateMerchantPortalCredentials(
    loginInput: string,
    password: string,
    confirmation: string,
): string | null {
    const credentials = validateCredentialLogin(loginInput) ?? validateCredentialPassword(password);
    if (credentials) {
        return credentials;
    }
    if (password !== confirmation) {
        return "Пароли не совпадают.";
    }
    return null;
}
